import React, { useContext, useState } from "react";
import { Grid, Typography } from "@mui/material";
import { MainContext } from "../../../state/state";

import sendRequest from "../../../helpers/service";
import { toast } from "react-toastify";
import ImageDropZone from "../../../components/ImageDropZone";
import handleError from "src/helpers/errorHandler";
import openDeleteModal from "src/helpers/deleteHandler";

export default function ImageTab({ detail, setDetail, permission }) {
  const { setLoading } = useContext(MainContext);

  const [thumbnail, setThumbnail] = useState(detail.thumbnail);

  const handleSubmit = async () => {
    if (!thumbnail || typeof thumbnail === "string") {
      toast("Please select an image first", {
        type: "error",
      });
      return;
    }

    setLoading(true);
    try {
      const img: any = await getMeta(thumbnail);

      const formData = new FormData();
      formData.append("content_id", detail.id);
      formData.append("thumbnail", thumbnail);
      formData.append("width", img.naturalWidth);
      formData.append("height", img.naturalHeight);
      formData.append("extension", thumbnail.type);

      const res = await sendRequest.post({
        url: "/live/upload-image",
        data: formData,
      });

      toast("Thumbnail uploaded successfully", {
        type: "success",
      });

      setThumbnail(res.data.thumbnail);
      setDetail((prev) => ({
        ...prev,
        thumbnail: res.data.thumbnail,
      }));

      setLoading(false);
    } catch (error) {
      console.log("error on thumbnail upload: ", error);
      handleError(error);
      setLoading(false);
    }
  };

  function handleDelete() {
    openDeleteModal({
      apiUrl: `live/delete-image/${detail.id}`,
      successText: "Thumbnail deleted successfully",
      modals: [
        {
          title: "Delete Thumbnail",
          message: `Are you sure to delete this thumbnail?`,
          cancelButton: {
            text: "Cancel",
          },
          confirmButton: {
            text: "Delete",
          },
        },
      ],
    }).then(() => {
      setThumbnail(null);
      setDetail((prev) => ({
        ...prev,
        thumbnail: null,
      }));
    });
  }

  const getMeta = (file) =>
    new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = (err) => reject(err);
      img.src = URL.createObjectURL(file);
    });

  return (
    <div>
      <Grid
        container
        spacing={2}
        mb={2}
      >
        <Grid
          item
          xs={12}
          md={6}
        >
          <ImageDropZone
            value={thumbnail}
            label={"Thumbnail"}
            onChange={setThumbnail}
            onUpload={handleSubmit}
            onDelete={handleDelete}
            // disabled={!permission?.live_schedule?.write}
            // placeholder="Select a thumbnail image"
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={6}
          className="p-2"
        >
          <Typography fontWeight={700}>Thumbnail Information</Typography>
          <Typography>• Upload a thumbnail image for the live event</Typography>
          <Typography>• Recommended size: 1920x1080 pixels</Typography>
          <Typography>• Supported formats: JPG, PNG</Typography>
        </Grid>
      </Grid>
    </div>
  );
}
